import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";
import type {SingUpRequest} from "./ModelTypes.ts";

export class SignupAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = et(localization);
    }
}

const apiVersion = 1;


export const signup = {
    async getConfig() {
        try {
            const response = await restfulApiClient.get("membership_config", apiVersion);
            return response!.data;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new SignupAPIConnectorError(err, err.cause);
            }
            throw err;
        }
    },
    async signup(data: SingUpRequest) {
        try {
            return await restfulApiClient.post("signup", 1, data);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new SignupAPIConnectorError(err, err.cause);
            }
            throw err;
        }
    },
}